import * as React from 'react'
import * as Cookies from 'js-cookie';
import { LoginForm, LogoCentered } from 'src/app/Partials';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import MESSAGES from './Login.messages';

import './Login.page.scss';
import '../../../../assets/sass/theme/errorform/errorform.scss';
import { appSettings } from 'src/config';
import { removeAccessTokenFromCookie } from 'loopback-react-request';
import TroughBanner from 'src/app/Partials/TroughBanner/TroughBanner';
import { GlobalPrivateState, cleanSearchQuery, filterComparativeParameter, queryParameterInitialState } from 'src/api';
import { parse } from 'qs';

export interface LoginPageProps {
  location: GlobalPrivateState['router']['location'];
}

export class LoginPage extends React.Component<LoginPageProps> {
  componentDidMount() {
    const authCookie = Cookies.get(appSettings.cookieName);
    if (authCookie) {
      removeAccessTokenFromCookie(appSettings.cookieName);
      window.location.reload();
    }    
  }
  public render() {
    const { location } = this.props;
    const search = cleanSearchQuery(location.search);
    const searchProps = parse(search);

    return (
      <div className="page-login d-flex justify-content-center align-items-center h-100">
        <div className="inner w-100 pt-5 pb-5">
          <LogoCentered withHome={false} />
          {searchProps && searchProps.from && searchProps.from === '/configuration/new' && (
            <div className="col-12 mb-4 font-weight-bold text-red small">
              <FormattedMessage {...MESSAGES.mustLogin} />
            </div>
          )}
          <LoginForm />
          <div className="meta d-flex mt-2">
            <div className="col-6 text-left">
              <p className="small">
                <Link to="/register">
                  <FormattedMessage {...MESSAGES.newUser} />
                </Link>
              </p>
            </div>
            <div className="col-6 text-right">
              <p className="small">
                <Link to="/reset-password">
                  <FormattedMessage  {...MESSAGES.forgotPassword} />
                </Link>
              </p>
            </div>
          </div>
          <div className="meta d-flex mt-5">
            <div className="row m-0 w-100">
              <div className="col-12">
                <TroughBanner />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}